import Image from 'next/image';

export default function Certificates() {
  return (
    <div className="flex min-h-[70px] w-full items-center justify-center overflow-x-auto md:my-10 lg:my-0">
      <div className="grid gap-3 md:gap-8 text-center text-sm font-semibold grid-cols-3">
        <div className="flex items-center justify-center gap-1 md:gap-2">
          <Image src={'/images/EU.svg'} alt="EU" width={50} height={50} className="w-[26px] md:w-[50px]" />
          <div className="max-w-[100px] text-balance text-[6px] md:text-[12px] leading-[10px] md:leading-normal text-muted-foreground">
            GDPR Compliant
          </div>
        </div>
        <div className="flex items-center justify-center gap-1 md:gap-2">
          <Image
            src={'/images/Germany.svg'}
            alt="Server Location"
            width={50}
            height={50}
            className="w-[26px] md:w-[50px]"
          />
          <div className="max-w-[100px] text-balance text-[6px] md:text-[12px] leading-[10px] md:leading-normal text-muted-foreground">
            Server Location: Germany
          </div>
        </div>
        <div className="flex items-center justify-center gap-1 md:gap-2">
          <Image src={'/images/key.svg'} alt="Keyed" width={50} height={50} className="w-[26px] md:w-[50px]" />

          <div className="line-clamp-2 max-w-[130px] text-balance text-[6px] md:text-[12px] leading-[10px] md:leading-normal text-muted-foreground">
            Keyed - External Data Protection Officer
          </div>
        </div>
      </div>
    </div>
  );
}
